import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'

axios.defaults.withCredentials=true
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
Vue.use(VueCookies)

new Vue({
  render: h => h(App),
}).$mount('#app')